import { PayloadAction } from '@reduxjs/toolkit';
import {
  ExcelFileNameTypes,
  IGenerationError,
  IGenerationProgress,
  IGenerationStateInitial,
} from './generation-state.types';

export const actions = {
  setPrefix(state: IGenerationStateInitial, { payload }: PayloadAction<string>) {
    state.prefix = payload;
  },
  setSendingState(state: IGenerationStateInitial, { payload }: PayloadAction<string>) {
    state.sendingStateId = payload;
  },
  resetSendingState(state: IGenerationStateInitial) {
    state.sendingStateId = '';
  },
  resetIsLoading(state: IGenerationStateInitial) {
    state.isLoading = false;
  },
  setGenerationIsLoading(state: IGenerationStateInitial, { payload }: PayloadAction<boolean>) {
    state.isLoading = payload;
  },
  resetSendingProgress(state: IGenerationStateInitial) {
    state.progress.generated = 0;
    state.progress.total = 0;
    state.progress.status = 'none';
  },
  updateProgress(state: IGenerationStateInitial, { payload }: PayloadAction<IGenerationProgress>) {
    state.progress.total = payload.total;
    state.progress.failed = payload.failed;
    state.progress.generated = payload.generated;
    state.progress.status = payload.status;
  },
  setGenerationStateDetails(state: IGenerationStateInitial, { payload }: PayloadAction<string>) {
    state.stateId = payload;
    state.isLoading = true;
  },
  resetGenerationProgress(state: IGenerationStateInitial) {
    state.isLoading = false;
    state.progress.generated = 0;
    state.progress.failed = 0;
    state.progress.total = 0;
    state.progress.status = 'none';
  },
  resetState(state: IGenerationStateInitial) {
    state.prefix = '';
    state.excelFiles.customerFileName = '';
    state.excelFiles.monthFileName = '';
    state.excelFiles.staffFileName = '';
  },
  resetGenerationErrors(state: IGenerationStateInitial) {
    state.progress.errors = [];
  },
  setGenerationErrors(state: IGenerationStateInitial, { payload }: PayloadAction<IGenerationError[]>) {
    state.progress.errors = [...payload];
  },
  setFileName(
    state: IGenerationStateInitial,
    { payload }: PayloadAction<{ file: ExcelFileNameTypes; filename: string }>
  ) {
    state.excelFiles[payload.file] = payload.filename;
  },
};
